import ButtonPrimary from "../buttons/ButtonPrimary";
import logo from '../images/logo.png';

import { TranslationContextProvider } from 'schummar-translate/react';
import t from '../translations/translate.ts';
import './TaskList.css';
import {ifRightToLeft, ifLeftToRight} from '../utils/ifLangDir.js';
import { useLocale } from '../LocaleContext';

export default function SignUpTaskListPage({ familyInfo, letsGo }) {
    const { locale } = useLocale();
    return <TranslationContextProvider locale={locale}>
        <div className="TaskListDiv" style={{ 
            direction: ifRightToLeft() ? 'rtl' : 'ltr',
        }}>
        <div style={{ width: 100, margin: 'auto', marginTop: 10 }}>
            <img src={logo} style={{ width: 100 }} alt="logo" />
        </div>
        <br />
        <div style={{ padding: 15 }}><i> {t('someTasksFrom')} <b>{familyInfo.title}</b>:</i></div>
        <div style={{ height: '38vh', overflowY: 'scroll', marginLeft: 10, marginRight: 10, marginTop: 5 }}>

            {familyInfo.tasks.no_time.filter((t) => t.assignee == null).map((t) => <div
                key={t.id}
                style={{ padding: 10, margin: 20, backgroundColor: '#F5F8FF', borderRadius: 10 }}
            >
                <b style={{ textAlign: 'center' }}>{t.title}</b> <br />
                {t.description}
            </div>)}

            {familyInfo.tasks.events.filter((t) => t.assignee == null).map((t) => <div
                key={t.id}
                style={{ padding: 10, margin: 20, borderRadius: 10, backgroundColor: '#F5F8FF' }}
            >
                <b style={{ textAlign: 'center' }}>{t.title}</b> <br />
                {t.description}
            </div>)}
        </div>
        
        <br />
        <div style={{ padding: 20 }}>
            {t('youShouldRegister')}<br />
            {t('afterRegistration')}
        </div>
        <div style={{ width: 250, margin: 'auto' }}>
            <ButtonPrimary onClick={letsGo}>{t('signUp')}</ButtonPrimary>
        </div>
        <br /><br />&nbsp;
    </div></TranslationContextProvider>
}